import {
  Grid,
  FormControl,
  Box,
  Typography,
  IconButton,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import Base from "../../../Base/views/Base";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import MaterialTable from "material-table";
import {
  AddEmployeeClearanceAction,
  DeleteEmployeeClearanceAction,
  GetEmployeeClearanceAction,
  UpdateEmployeeClearanceAction,
} from "../../../../../store/Employee/EmployeeClearance/Action";
import AddIcon from "@mui/icons-material/Add";
import "jspdf-autotable";
import CommentIcon from "@mui/icons-material/Comment";
import { GetECMSClearanceTypeHelper } from "../../../Ancillary/ECMS/helper/ClearanceHelper";
import { GetEmployeesHelper } from "../../../Employee/helper/EmployeeHelper";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ConvertDate } from "../../../Base/helper/baseFunctions";

const EmployeeClearanceGrid = () => {
  const dispatch = useDispatch();
  const date = new Date();

  const { employeeClearanceLoading, employeeClearanceData } = useSelector(
    (state) => state?.EmployeeReducer?.EmployeeClearanceReducer
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [clearanceComponentData, setClearanceComponentData] = useState({
    load: true,
    values: [],
  });
  const currentDate = new Date();
  const formattedToday = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;
  const formattedFirstDay = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-01`;
  
  const default_date = `${
    date?.getFullYear() +
    "-" +
    ("0" + (date?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date?.getDate()).slice(-2)
  }`;

  const [filters, setFilters] = useState({
    full_date: default_date,
    from_date: formattedFirstDay,
    to_date: formattedToday,
  });

  const handleEmployees = () => {
    GetEmployeesHelper({ is_active: true }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeesData({ load: false, values: res?.data?.data });
      } else {
        setEmployeesData({ load: false, values: [] });
      }
    });
  };

  const handleClearanceType = () => {
    GetECMSClearanceTypeHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setClearanceComponentData({ load: false, values: res?.data?.data });
      } else {
        setClearanceComponentData({ load: false, values: [] });
      }
    });
  };

  const formatDataStructure = (data) => {
    if (!data || data?.length === 0) return [];

    return data?.map((employee) => {
      return {
        ...employee,
        employee_id: {
          employee_id: employee?.employee_id,
          name: employee?.employee_name,
        },
        clearance_type_configuration_pk: {clearance_type_configuration_pk: employee?.clearance_type_configuration_fk, clearance_type: employee?.clearance_type_name }
      };
    });
  };
  const adjustmentRows = formatDataStructure(employeeClearanceData) || [];

  useEffect(() => {
    dispatch(GetEmployeeClearanceAction({ from_date: filters?.from_date, to_date: filters?.to_date }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);


  const handleSubmitRowData = (rowData, actionType) => {
    if (actionType === "add") {
      dispatch(
        AddEmployeeClearanceAction({
          employee_fk: rowData?.employee_id?.employee_id,
          from_date: filters?.from_date, 
          to_date: filters?.to_date,
          record_date: rowData?.record_date
          ? convertDateFormat(rowData?.record_date)
          : formattedToday,
          comment: rowData?.comments || "",
          clearance_type_configuration_fk: rowData?.clearance_type_configuration_pk?.clearance_type_configuration_pk,
        })

      );
    } else if (actionType === "edit") {
      dispatch(
        UpdateEmployeeClearanceAction({
          employee_fk: rowData?.employee_id?.employee_id,
          from_date: filters?.from_date, 
          to_date: filters?.to_date,
          record_date: rowData?.record_date,
          comment: rowData?.comments || "",
          employee_clearance_mapping_id: rowData?.employee_clearance_mapping_id,
          clearance_type_configuration_fk: rowData?.clearance_type_configuration_pk?.clearance_type_configuration_pk,
        })
      );
    } else if (actionType === "delete") {
      dispatch(
        DeleteEmployeeClearanceAction({
          employee_clearance_mapping_id: rowData?.employee_clearance_mapping_id,
          from_date: filters?.from_date, 
          to_date: filters?.to_date
        })
      );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const convertDateFormat = (date) => {
    // always accept argument as new Date() object
    if (!date) return "";
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const handlePrevMonth = () => {
    const prevMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    const firstDayOfPrevMonth = `${prevMonth.getFullYear()}-${(
      "0" +
      (prevMonth.getMonth() + 1)
    ).slice(-2)}-01`;
    const lastDayOfPrevMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      0
    );
    const lastDayFormatted = `${lastDayOfPrevMonth.getFullYear()}-${(
      "0" +
      (lastDayOfPrevMonth.getMonth() + 1)
    ).slice(-2)}-${("0" + lastDayOfPrevMonth.getDate()).slice(-2)}`;
    setFilters({
      ...filters,
      from_date: firstDayOfPrevMonth,
      to_date: lastDayFormatted,
    });
    setCurrentMonth(prevMonth);
  };
  const handleNextMonth = () => {
    const nextMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    const firstDayOfNextMonth = `${nextMonth.getFullYear()}-${(
      "0" +
      (nextMonth.getMonth() + 1)
    ).slice(-2)}-01`;
    const lastDayOfNextMonth = new Date(
      nextMonth.getFullYear(),
      nextMonth.getMonth() + 1,
      0
    );
    const lastDayFormatted = `${lastDayOfNextMonth.getFullYear()}-${(
      "0" +
      (lastDayOfNextMonth.getMonth() + 1)
    ).slice(-2)}-${("0" + lastDayOfNextMonth.getDate()).slice(-2)}`;
    setFilters({
      ...filters,
      from_date: firstDayOfNextMonth,
      to_date: lastDayFormatted,
    });
    setCurrentMonth(nextMonth);
  };
  const handleFilter = (event, value) => {
    if (["from_date", "to_date"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };
  const titleContent = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Employees
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Track and manage company assets assigned to employees
      </Typography>
    </Box>
  );
  return (
    <Base>
      <Box
        sx={{
          maxHeight: "calc(100vh - 65px)",
          overflowY: "auto",
        }}
      >
        <Grid
          pt={2}
          pb={1}
          container
          justifyContent="flex-end"
          alignItems="center"
          spacing={1}
          pr={2}
        >
          <Grid item>
            <IconButton onClick={handlePrevMonth}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <FormControl>
              <CommonDatePicker
                name="from_date"
                label="From Date"
                size="small"
                pickerType="date"
                onKeyPress={(e) => e.preventDefault()}
                pickerFormat="dd/MM/yyyy"
                DefaultDTvalue={filters.from_date}
                maxDate={filters.to_date ? new Date(filters.to_date) : new Date()}
                minDate={
                  new Date(new Date(minDojYear).getFullYear() - 1, 0, 31)
                }
                handleChange={(value) =>
                  handleFilter({
                    target: {
                      name: "from_date",
                      value: value
                        ? `${
                            value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                          }`
                        : "",
                    },
                  })
                }
              />
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl>
              <CommonDatePicker
                name="to_date"
                label="To Date"
                pickerType="date"
                size="small"
                onKeyPress={(e) => e.preventDefault()}
                pickerFormat="dd/MM/yyyy"
                DefaultDTvalue={filters.to_date}
                minDate={filters.from_date ? new Date(filters.from_date) : null}
                maxDate={currentDate}
                handleChange={(value) =>
                  handleFilter({
                    target: {
                      name: "to_date",
                      value: value
                        ? `${
                            value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                          }`
                        : "",
                    },
                  })
                }
              />
            </FormControl>
            <IconButton onClick={handleNextMonth}>
              <ArrowForwardIosIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Box>
          <MaterialTable
            isLoading={employeeClearanceLoading}
            columns={[
              {
                title: "Entry Date",
                headerStyle: {
                  width: "20%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "20%",
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                field: "record_date",
                render: (rowData) => ConvertDate(rowData?.record_date),
                grouping: false,
                editComponent: (props) => {
                  return (
                    <Box sx={{ width: "100%", ml: -2 }}>
                      <FormControl fullWidth>
                        <CommonDatePicker
                          size="small"
                          name="record_date"
                          label="Entry Date"
                          pickerType="date"
                          onKeyPress={(e) => e.preventDefault()}
                          onKeyDown={(e) => e.preventDefault()}
                          required={true}
                          pickerFormat="dd/MM/yyyy"
                          DefaultDTvalue={
                            props.value
                              ? props.value
                              : formattedToday
                          }
                          minDate={
                            new Date(new Date(minDojYear).getFullYear() - 1, 0, 31)
                          }
                          maxDate={new Date(new Date().getFullYear() + 1, 0, 31)}
                          handleChange={(value) => {
                            props.onChange(value);
                          }}
                        />
                      </FormControl>
                    </Box>
                  );
                },
              },
              {
                title: "Employee",
                headerStyle: {
                  width: "25%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "25%",
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                field: "employee_id",
                grouping: false,
                customSort: (a, b) => (a.employee_id?.name || "").localeCompare(b.employee_id?.name || ""),
                validate: (rowData) => {
                  if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                    return ""; 
                  }
                  if (rowData.employee_id?.name) {
                    return "";
                  } else {
                    return "Employee cannot be empty";
                  }
                },
                render: (rowData) => rowData.employee_id?.name || "",
                editComponent: (props) => {
                  const isEdit = props.rowData?.tableData?.editing === "update";
                  return (
                    <Box sx={{ width: "100%" }}>
                      <SelectableSearch
                        fullWidth
                        variantType="standard"
                        size="small"
                        required
                        disabled={isEdit}
                        loading={() => handleEmployees()}
                        placeholder="Select Employee"
                        value={props.value}
                        fieldLabel="name"
                        name="employee_id"
                        onChangeEvent={(e, v) => {
                          props.onChange(v);
                        }}
                        data={employeesData}
                      />
                    </Box>
                  );
                },
                customFilterAndSearch: (search, rowData) =>
                  (rowData?.employee_id?.name || "")
                    .toLowerCase()
                    .includes(search.toLowerCase()),
              },
              {
                title: "Asset",
                headerStyle: {
                  width: "25%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "25%",
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                field: "clearance_type_configuration_pk",
                grouping: false,
                customSort: (a, b) => (a.clearance_type_configuration_pk?.clearance_type || "").localeCompare(b.clearance_type_configuration_pk?.clearance_type || ""),
                validate: (rowData) => {
                  if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                    return ""; 
                  }
                  if (rowData.clearance_type_configuration_pk?.clearance_type) {
                    return "";
                  } else {
                    return "Component cannot be empty";
                  }
                },
                render: (rowData) =>
                  rowData.clearance_type_configuration_pk?.clearance_type || "",
                editComponent: (props) => {
                  return (
                    <Box sx={{ width: "95%" }}>
                      <SelectableSearch
                        fullWidth
                        required
                        variantType="standard"
                        size="small"
                        loading={handleClearanceType}
                        placeholder="Select Component"
                        value={props.value || ""}
                        fieldLabel="clearance_type"
                        name="clearance_type_configuration_pk"
                        onChangeEvent={(e, v) => {
                          props.onChange(v);
                        }}
                        data={clearanceComponentData}
                      />
                    </Box>
                  );
                },
              },

              {
                title: "Comment",
                headerStyle: {
                  width: "20%",
                  textAlign: "center",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "20%",
                  textAlign: "center",
                  padding: "5px 0px 0px 2%",
                },
                field: "comments",
                grouping: false,
                sorting: false,
                render: (rowData) => {
                  return (
                    <Box width={"90%"}>
                      <Tooltip title={rowData.comments || ""} arrow>
                        <CommentIcon
                          sx={{
                            fontSize: "20px",
                            color: rowData.comments ? "#637381" : "#95a0ab",
                            cursor: rowData.comments ? "pointer" : "default",
                          }}
                        />
                      </Tooltip>
                    </Box>
                  );
                },
                editComponent: (props) => {
                  return (
                    <Box width={"100%"}>
                      <TextareaAutosize
                        minRows={1}
                        maxRows={1}
                        placeholder={"Comment"}
                        value={props.value || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 50) {
                            props.onChange(value);
                          }
                        }}
                        style={{
                          width: "100%",
                          borderRadius: "5px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />

                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textAlign: "right",
                          color: "#888",
                        }}
                      >
                        {props.rowData?.comments?.length || 0}/50
                      </Typography>
                    </Box>
                  );
                },
              },
            ]}
            data={adjustmentRows}
            options={{
              maxBodyHeight: "calc(100vh - 235px)",
              minBodyHeight: "calc(100vh - 235px)",
              rowStyle: { fontSize: "13px", height: "30px" },
              headerStyle: {
                padding: "7px 0px 7px 0px",
                fontWeight: "bold",
              },
              sorting: true,
              search: true,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: false,
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              grouping: false,
              columnsButton: false,
            }}
            icons={{
              Add: () => <AddIcon sx={{ color: !ExternalUserCoreHr ? "#637381" : "#bdbdbd", cursor: !ExternalUserCoreHr ? "pointer" : "not-allowed"}} />,
              Edit: () => <EditIcon sx={{ color: "#637381" }} />,
              Delete: () => <DeleteIcon sx={{ color: "#637381" }} />,
            }}
            editable={{
              onRowAdd: (newRow) =>
                new Promise((resolve, reject) => {
                  if (ExternalUserCoreHr) {
                    reject();
                    return;
                  }
                  if (!newRow?.employee_id?.name) {
                    return reject();
                  }
                  if (!newRow?.clearance_type_configuration_pk?.clearance_type) {
                    return reject();
                  }
                  handleSubmitRowData(newRow, "add");
                  setTimeout(() => resolve(), 500);
                }),
              onRowUpdate: (newRow, oldRow) =>
                new Promise((resolve, reject) => {
                  if (!newRow?.employee_id?.name) {
                    return reject();
                  }
                  if (!newRow?.clearance_type_configuration_pk?.clearance_type) {
                    return reject();
                  }
                  handleSubmitRowData(newRow, "edit");
                  setTimeout(() => resolve(), 500);
                }),
              onRowDelete: (selectedRow) =>
                new Promise((resolve, reject) => {
                  handleSubmitRowData(selectedRow, "delete");
                  setTimeout(() => resolve(), 1000);
                }),
            }}
            title={titleContent}
          />
        </Box>
      </Box>
    </Base>
  );
};

export default EmployeeClearanceGrid;
